export const GA_TRACKING_ID = 'UA-108240198-2';
export const DEMO_USERS_IDS = [
    50, // NBADemo@gumgum.com
    51, // NHLDemo@gumgum.com
    168, // NFLDemo@gumgum.com
    278, // uefaCL2017@gumgum.com
    279, // gg-uefaCL2017@gumgum.com
    201, // 2017MonacoGP@gumgum.com
    202, // WilliamsF1@gumgum.com
];

export const FB_APP_VERSION = 'v26.0';
// Webpack DefinePlugin sets __PROD_API__ in app builds; Jest does not, so guard with typeof.
export const FB_APP_ID =
    typeof __PROD_API__ !== 'undefined' && __PROD_API__
        ? '1985458231781808'
        : '360580391182944';

// Permissions
export const PREMIUM_POST_LEVEL_INSIGHTS = 1;
export const PREMIUM_COLLECTIONS = 2;
export const PREMIUM_SMP_BELOW_THIRTY_PERCENT = 3;
export const INSTAGRAM_STORIES_ANALYSIS = 6;
export const PREMIUM_REPORTS = 9;
export const PREMIUM_PLACEMENT_TYPES = 12;
export const CURRENT_METHODOLOGY = 10;
export const API_DOCUMENTATION = 14;
// Programmatic API access. Matches sports-api ClientPermissionTypeEnum.API_ACCESS(39),
// surfaced via GET /v1/users/me -> client.permissions: number[].
// NOTE: API_DOCUMENTATION (14) above is dead code (referenced nowhere); do not reuse it.
export const API_ACCESS = 39;
// Gates the native, in-product API documentation (SP-8216). Off by default and
// rolled out per-client; clients without it keep the legacy HubSpot PDF link.
// Matches client_permission_types.id = 64 ("API LIVE DOCS").
export const API_LIVE_DOCS = 64;
export const AUDIENCE_INSIGHTS = 16;
export const ACCOUNT_OWNERSHIP_ACCESS = [
    { accessId: 17, ownershipId: 10 }, // BRAND
    { accessId: 19, ownershipId: 11 }, // TEAM
    { accessId: 20, ownershipId: 12 }, // EVENT
];

export const INFINITE_SCROLL_ACCESS = 21;
export const AUTOMATED_COLLECTIONS = 25;

export const SOCIAL_BENCHMARKING = 28;
export const VIDEO_IMPRESSIONS = 27;
export const PLATFORM_NOTIFICATIONS = 29;
export const TEXT_TRACKING = 31;

export const PACING_VIEW_GOALS = 34;
export const PACING_CREATE_GOALS = 33;

export const HOME_PAGE = 35;
export const INSIGHT_PAGE = 36;
export const SOCIAL_MEDIA_POST_PAGE = 37;
export const VALUATION_INSIGHTS = 38;
export const ALL_SOCIAL_MEDIA_POSTS_PAGE = 41;

export const FILTER_REDESIGN = 40;
export const LINKED_FILTER_LOGIC = 44;
export const STANDARD_PLACEMENT_EXPERIENCE = 42;
export const BROADCAST_IMPRESSIONS = 46;
export const INTERNAL_USER_PLACEMENTS = 47;
export const IN_STADIUM_ANALYTICS = 48;
export const CENSUS_ACCESS = 51;
export const AUTOMATED_CAMPAIGNS = 52;
export const BROADCAST_IMPRESSIONS_FULL_MVC = 53;
export const AI_INSIGHTS = 54;
export const FB_REFACTOR = 55;
export const INTERNATIONAL_BROADCAST_VIEW = 58;
export const MVC_REFRESH = 57;
export const VERBAL_MENTIONS_TRACKING = 59;
export const EDGE_RIGHTSHOLDER_ATTRIBUTION = 60;
export const GROUP_BY_BROADCAST_METADATA = 62;
export const BROADCAST_DEMOGRAPHICS = 66;
// Gates the Reports-only broadcast country selector. This deliberately does
// not grant access to the existing Edge country controls (permission 58).
export const REPORTS_BROADCAST_COUNTRY_FILTER = 67;
export const RELO_LOGO =
    'https://sports-cdn.rmdevops.com/general-assets/logos/reloLogo.png';
